import { useGetVisitDetailsQuery } from "../../features/visit/visitApi";
import useError from "../../hooks/useError";
import { ModalComponentProps } from "../../types";
import { capitalize } from "../../utils/string";
import InfoItem from "../common/InfoItem";
import CustomModal from "../ui/CustomModal";
import Loader from "../ui/Loader";

const statusStyle = {
  created: "bg-status-warning-text",
  completed: "bg-status-success-text",
  reached: "bg-status-info-text",
  started: "bg-status-info-text",
  cancelled: "bg-status-danger-text",
  rescheduled: "bg-status-dark-text",
} as const;

export default function VisitDetailsModal({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<number>) {
  const {
    data: visitDetailsData,
    isError,
    error,
    isLoading,
  } = useGetVisitDetailsQuery(String(data), {
    skip: !data,
  });
  useError(isError, error, "Get visit details data fail");

  const detailsData = visitDetailsData?.data;

  return (
    <CustomModal
      title="Visit Details"
      {...rest}
      handleClose={handleClose}
      width={600}
      footer={null}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <InfoItem title="Title">{detailsData?.title}</InfoItem>
          <InfoItem title="Status">
            <span
              className={`h-8 px-2 rounded-md justify-center items-center inline-flex text-white text-sm font-medium ${
                statusStyle[detailsData?.status as keyof typeof statusStyle]
              }`}
            >
              {capitalize(detailsData?.status || "")}
            </span>
          </InfoItem>
        </>
      )}
    </CustomModal>
  );
}
